import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../../Helper/Helper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";

function CleanGridServicesListing() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [isLoading, setIsLoading] = useState(true);
  const [isData, setIsdata] = useState(false);
  const [servicesData, setServicesData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesData();
  }, []);

  const getServicesData = async () => {
    const response = await SendPostRequest("services/list");
    setIsLoading(false);

    if (!response?.data || response?.data?.length < 1) {
      setIsdata(true);
    } else {
      setServicesData(response.data);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />

        <TextMainBannerWrapper
          Heading={sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
          Image="theme-2-banner-speciality.webp"
        />


        <div className="container">
          {sitedata?.site_type === "hospitals" ? (
            <div className="row mt-5">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-60">
                    <h2 className="section-title mb-0 text-uppercase">
                      Provides Our{" "}
                      <span className="theme-color">Best Specialties</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-5"></div>
          )}

          <div
            className="row portfolio-wrap portfolio-classic my-3"
            data-animation="fadeInDown"
          >
            {isLoading ? (
              <div className="col-12 text-center">
                <Spinner />
              </div>
            ) : isData ? (
              <div className="col-12 text-center mb-4">
                <h4>No Record Available</h4>
              </div>
            ) : (
              servicesData.map((service, index) => (
                <div
                  className={`portfolio-item portfolio-overlay-wrap col-lg-4 col-md-4 col-sm-4 mb-4 col-xs-6 filter ${service.category || "general"
                    }`}
                  key={index}
                >
                  <div className="portfolio-thumb relative cleangrid-services-mobile-view">
                    <Link
                      to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                        .replaceAll(" ", "-")
                        .replaceAll("/", "-")}`}
                    >
                      <img
                        src={service?.service_image_url}
                        className="img-fluid"
                        alt={service?.title}
                        title={service?.service_title}
                        style={{ height: "auto" }}
                      />
                    </Link>
                    <div className="portfolio-wrap ">
                      <div className="portfolio-details-overlay home-speciality-title-color ">
                        <Link
                          to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "-")}`}
                        >
                          <h4 className="mb-3 home-speciality-title-color">
                            {service?.service_title}
                          </h4>
                        </Link>
                        <div className="portfolio-icons">
                          <Link
                            to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                              .replaceAll(" ", "-")
                              .replaceAll("/", "-")}`}
                            className="link-icon"
                          >
                            <i className="icon-link text-white"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <FooterWrapper />
      </div>
    </div>
  );
}

export default CleanGridServicesListing;
